export const TIMER_REPEAT_LOGIN_CODE_TIME = 60000
export const TIMER_REPEAT_LOGIN_CODE = 'timer_repeat_login_code'

export enum LoginStepsEnum {
  LOGIN_PHONE = 'LOGIN_PHONE',
  LOGIN_CODE = 'LOGIN_CODE',
}
